import { CircularProgress } from '@rmwc/circular-progress'
import { FC } from 'react'
import './LoadingProgress.style.sass'

export const LoadingProgress: FC = (): JSX.Element => {
	return (
		<div className='loading-wrapper'>
			<div className='loading-inner'>
				<CircularProgress className='circular-progress' />
				<div>Загрузка</div>
			</div>
		</div>
	)
}
